export enum QuestionType {
    Date = 'date',
    MonthYear = 'monthyear',
    Boolean = 'boolean',
    Select = 'select',
    Text = 'text',
    Radio = 'radio',
    Checkbox = 'checkbox',
    DropdownSingle = 'dropdown_single',
    DropdownMulti = 'dropdown_multi',
    SearchSingle = 'search_single',
    SearchMulti = 'search_multi',
    SearchSingleMultiInstance = 'search_single_multi_instance',
    SearchMultiMultiInstance = 'search_multi_multi_instance'
}

export enum QuestionStyle {
    PRIMARY = 'primary',
    SECONDARY = 'secondary',
    TERTIARY = 'tertiary'
};

export enum QuestionDisplay {
    NORMAL = 'normal',
    READ_ONLY = 'read-only',
    HIDDEN = 'hidden'
};

export interface IQuestion {
    id?: number;
    page_id: number;
    criteria_group_id?: number;
    question_option_id?: number;
    repeat_id?: number;
    questionnaire_code: string;
    code?: string;
    order: number;
    type?: QuestionType;
    question: string;
    question_paragraph?: string;
    comment?: string;
    why_ask?: string;
    help?: string;
    placeholder?: string;
    pattern_mask?: string;
    validation_regex?: string;
    answers_min?: number;
    answers_max?: number;
    day_past?: number;
    day_future?: number;
    limit_min?: number;
    limit_max?: number;
    style: QuestionStyle;
    display: QuestionDisplay;
    page: any;
}